import ExampleTheme from "./themes/ExampleTheme";
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { AutoFocusPlugin } from "@lexical/react/LexicalAutoFocusPlugin";
import LexicalErrorBoundary from "@lexical/react/LexicalErrorBoundary";
import TreeViewPlugin from "./plugins/TreeViewPlugin";
import ToolbarPlugin from "./plugins/ToolbarPlugin";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { TableCellNode, TableNode, TableRowNode } from "@lexical/table";
import { ListItemNode, ListNode } from "@lexical/list";
import { CodeHighlightNode, CodeNode } from "@lexical/code";
import { AutoLinkNode, LinkNode } from "@lexical/link";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { MarkdownShortcutPlugin } from "@lexical/react/LexicalMarkdownShortcutPlugin";
import { TRANSFORMERS } from "@lexical/markdown";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import React, { useEffect, useState, useRef } from 'react'
import {
  CAN_REDO_COMMAND,
  CAN_UNDO_COMMAND,
  REDO_COMMAND,
  UNDO_COMMAND,
  SELECTION_CHANGE_COMMAND,
  FORMAT_TEXT_COMMAND,
  FORMAT_ELEMENT_COMMAND,
  $getSelection,
  $isRangeSelection,
  $createParagraphNode,
  $createTextNode,
  $getRoot
} from "lexical";

import { $generateNodesFromDOM } from '@lexical/html';


import ListMaxIndentLevelPlugin from "./plugins/ListMaxIndentLevelPlugin";
import CodeHighlightPlugin from "./plugins/CodeHighlightPlugin";
import AutoLinkPlugin from "./plugins/AutoLinkPlugin";
import { BinaryOperatorToken } from "typescript";
import DocPanel from '../../documentation/DocPanel';
import useApi from '../../api';

import { ToastContainer, toast, ToastOptions } from 'react-toastify';
import toastConfig from '../../config/Toast';
import 'react-toastify/dist/ReactToastify.css';

import { FormField, OwnerInterface } from '../../types'
import { useOutsideAlerter } from '../../useOutsideAlerter';
import Spinner from '../../documentation/Spinner';
import { set } from 'lodash';
import Consumer from '../../Consumer';
import FieldSelect from '../../ui/FieldSelect';
import MarkdownEditor from '../../ui/MarkdownEditor';


function Placeholder() {
  return <div className="text-[#999] overflow-hidden absolute text-ellipsis top-[15px] left-[10px] text-[15px] select-none inline-block pointer-events-none p-2">Write documentation here...</div>;
}

interface EditorProps {
    docId: string | undefined;
    contentId: string | undefined;
    fields: FormField[];
    modalRef: any;
    toggleModal: any
    setContents: any
    modalVisible: boolean
}

export default function ContentEditor({ docId, contentId, fields, modalRef, toggleModal, setContents, modalVisible }: EditorProps) {
  const [results, setResults] = useState<any>([]);
  const [documents, setDocuments] = useState<any[]>([]);
  const [contextDocs, setContextDocs] = useState<any[]>([]);
  const [contId, setContId] = useState<string | undefined>(contentId);
  const [content, setContent] = useState<any>('');
  const [contentName, setContentName] = useState<string>('');
  const [contentDescription, setContentDescription] = useState<string>('');
  const [userInput, setUserInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [consumers, setConsumers] = useState<OwnerInterface[]>([]);
  const [selectedFields, setSelectedFields] = useState<FormField[]>([]);
  const [assistantResponse, setAssistantResponse] = useState('');
  const [editDescription, setEditDescription] = useState(false);
  const [editName, setEditName] = useState(false);
  const { get, getStream, post, postStream, put, patch, remove } = useApi();

  const nameRef = useRef(null);
  const descriptionRef = useRef(null);

  console.log(content)

  useOutsideAlerter(nameRef, () => {
      setContentName(contentName);
      setEditName(false);
  });

  useOutsideAlerter(descriptionRef, () => {
      setContentDescription(contentDescription);
      setEditDescription(false)

  });

  const addConsumer = async (consumer: OwnerInterface) => {
      try {
          setLoading(true);
          // const payload = {
          //     consumer_id: consumer.id,
          //     consumer_type: consumer.type,
          //     consumer_name: consumer.name
          // }
          setConsumers([...consumers, consumer]);
      } catch (error) {
          console.error('Error:', error);
      }
      setLoading(false);
  };

  const removeConsumer = async (consumer: OwnerInterface) => {
      try {
          setLoading(true);
          // const payload = {
          //     consumer_id: consumer.id,
          //     consumer_type: consumer.type,
          //     consumer_name: consumer.name
          // }
          setConsumers(consumers.filter((user) => user.id !== consumer.id));
      } catch (error) {
          console.error('Error:', error);
      }
      setLoading(false);
  };

  const consumeStream = async (stream: any) => {
      const reader = stream.getReader();
      let receivedText = ''; // To accumulate the converted text
      let conversationId = '';
      try {
          let chunkText = ''; // To store the chunk text

          while (true) {
              const { done, value } = await reader.read();
              if (done) break;

              // Convert the Uint8Array to String
              const chunk = new TextDecoder().decode(value);
              chunkText += chunk;

              // Split the chunk text by newline character
              const chunks = chunkText.split('\n');

              // Process each chunk
              for (let i = 0; i < chunks.length - 1; i++) {
                  const chunk = chunks[i];

                  // Attempt to parse JSON text and handle the data
                  try {
                      const data = JSON.parse(chunk);

                      if (data.type === 'assistant' && data.content) {
                          console.log(data.content)
                          receivedText += data.content;
                          setContent(receivedText);
                      }

                  } catch (error) {
                      console.error("Error parsing JSON from chunk", error);
                  }
              }

              // Store the remaining chunk for the next iteration
              chunkText = chunks[chunks.length - 1];
          }
      } catch (error) {
          console.error("Error reading from stream", error);
      } finally {
      }

  };

  const generateContent = async () => {
      console.log('creating content')
      const data = {
          document_id: docId,
          fields: selectedFields,
          content: { name: contentName, description: contentDescription },
          message: { role: "user", content: userInput, created_at: new Date().toISOString() },
          consumers: consumers
      }

      console.log(data)

      postStream('/content/generate/', data)
          .then(async ({ stream }) => {
              const convId = await consumeStream(stream);

          })
          .catch(error => console.error('Streaming error:', error));

      setLoading(false);
      setUserInput('');
  };

  const createContent = async () => {
      setLoading(true);
      const data = {
          document_id: docId,
          fields: selectedFields,
          content: { name: contentName, description: contentDescription, content },
          consumers: consumers
      }

      console.log(data)
      console.log(contentId)

      try {
          if (contentId) {
              put(`/content/${contentId}`, data)
                  .then(async (response) => {
                      console.log(response.data);
                      setLoading(false);
                      toggleModal();
                  })
                  .catch(error => {
                      console.error('Error creating content:', error);
                      setLoading(false);
                  });
          } else {
              post('/content/', data)
              .then(async (response) => {
                  console.log(response.data);
                  setLoading(false);
                  toggleModal();
                  setContents((prev: any) => [...prev, response.data]);
              })
              .catch(error => {
                  console.error('Error creating content:', error);
                  setLoading(false);
              });
  
          }
          toast.success(`${contentName} succesfully updated.`, toastConfig);

      } catch (error) {
          toast.error(`${contentName} failed to update.`, toastConfig);
          console.error('Error creating content:', error);
      }
     

  };

  // set content if contentId is passed
  useEffect(() => {
      if (contentId) {
          // call api to get content
          const fetchContent = async () => {
              setLoading(true)
              try {
                  const response = await get(`/content/${contentId}`);
                  const data = response.data;
                  console.log(data)
                  setContent(data.content.content);
                  setContentName(data.content.name);
                  setContentDescription(data.content.description);
                  setConsumers(data.consumers);
                  setSelectedFields(data.fields);
              } catch (error) {
                  console.error('Error fetching content:', error);
              }
              setLoading(false);
          };
          fetchContent();
      }
  }, [contentId]);

  // default all fields to set if contentId is not passed
  useEffect(() => {
      if (!contentId) {
          setSelectedFields(fields);
      }
  }, []);


  console.log(contentId)
  const editorConfig = {
    // The editor theme
    theme: ExampleTheme,
    // Handling of errors during update
    editorState: content.value ? JSON.stringify(content.value) : null,
    namespace: `editor-content-${contentId}`,
    onError(error: any) {
      throw error;
    },
    // Any custom nodes go here
    nodes: [
      HeadingNode,
      ListNode,
      ListItemNode,
      QuoteNode,
      CodeNode,
      CodeHighlightNode,
      TableNode,
      TableCellNode,
      TableRowNode,
      AutoLinkNode,
      LinkNode
    ]
  };


  return (
    contentId && contentName === "" ? <Spinner /> : 
    <LexicalComposer initialConfig={editorConfig}>
        <div className="place-content-center fixed inset-0 bg-gray-600 bg-opacity-50 backdrop-blur-sm overflow-y-auto h-screen w-screen z-40 flex items-center justify-center">
          <div className="flex h-5/6 w-2/3 items-center justify-center mb-16">
            <div ref={modalRef} className="flex flex-row h-full w-full">
              <div className="flex flex-col w-full h-full">
          <ToolbarPlugin content={content} docId={docId} field={""} updateSchema={setContent} path={""} mode={"content"} setModalVisible={toggleModal} modalVisible={modalVisible} userInput={""} contextDocs={""} setUserInput={""} messageSent={""} setMessageSent={""} />
                  <div className="bg-white relative h-5/6">
                    <div className="flex flex-col h-full w-full">
                      <div className="flex flex-col h-full grow w-full">
                    <div className={`flex flex-col h-full ${isCollapsed ? '' : 'pb-14'}`}>
                            <div className="flex flex-grow overflow-hidden">
                                <div className="flex flex-col w-full">
                                    <div className="flex h-full">
                                    {content === "" || content['text_value'] === "" ? (
                                        <div></div>
                                    ) : (
                                        <div className="flex w-3/4 h-full overflow-y-auto scrollbar-thin p-2">
                                        <RichTextPlugin
                                        contentEditable={<ContentEditable className="min-h-[150px] text-[15px] relative tab-size-1 outline-none p-[15px_10px] caret-[#444] max-h-full w-full" />}
                                        placeholder={<Placeholder />}
                                        ErrorBoundary={LexicalErrorBoundary}
                                        />
                                        </div>
                                    )}
                                        <div className={`pb-16 ${content === "" || content['text_value'] === "" ? "w-full h-full justify-center" : "flex flex-col h-full"} bg-gray-50 overflow-y-auto scrollbar-thin p-8 shadow-lg`}>

                                            <div className="hover:shadow-sm hover:cursor-pointer rounded-lg mr-3" onClick={() => setEditName(true)} ref={nameRef}>
                                                {editName ? (
                                                    <div className="">
                                                        <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300">
                                                            <input
                                                                type="text"
                                                                name="name"
                                                                id="name"
                                                                autoComplete="off"
                                                                className="block flex-1 border-0 bg-transparent py-1.5 pl-2 text-gray-900 placeholder:text-gray-400 rounded-md focus:border-blue-300 focus:ring focus:ring-blue-50 sm:text-3xl focus:ring-opacity-50 sm:leading-6"
                                                                placeholder=""
                                                                value={contentName || ''}
                                                                onChange={(e) => setContentName(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <h2 className="text-3xl font-semibold leading-6 text-gray-900 py-1.5 whitespace-pre-wrap truncate">{contentName !== "" ? contentName : "Artifact Title"}</h2>
                                                )}
                                            </div>

                                            {/* <h2 className="text-md font-semibold leading-7 text-blue-900 mt-1">{`ID: ${docId}`}</h2> */}
                                            <div className="hover:shadow-sm hover:cursor-pointer rounded-lg" onClick={() => setEditDescription(true)} ref={descriptionRef}>
                                                {editDescription ? (
                                                    <div className="mt-3">
                                                        <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300">
                                                            <input
                                                                type="text"
                                                                name="description"
                                                                id="description"
                                                                autoComplete="off"
                                                                className="block flex-1 border-0 bg-transparent py-1.5 pl-2 text-gray-900 placeholder:text-gray-400 rounded-md focus:border-blue-300 focus:ring focus:ring-blue-50 sm:text-md focus:ring-opacity-50 sm:leading-6"
                                                                placeholder=""
                                                                value={contentDescription || ''}
                                                                onChange={(e) => setContentDescription(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <p className="mt-3 text-md leading-6 text-gray-600 py-1.5 whitespace-pre-wrap truncate">{contentDescription || "Enter a description"}</p>
                                                )}
                                            </div>
                                            <Consumer consumers={consumers} addConsumer={addConsumer} removeConsumer={removeConsumer} />
                                            <div className="mt-6">
                                                <label className="block text-sm font-medium leading-6 text-gray-900 pb-1">
                                                    Select Fields
                                                </label>
                                  
                                                <FieldSelect fields={fields} selectedFields={selectedFields} setFields={setSelectedFields} />
                                           
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                    </div>

                                </div>

                            </div>

                        </div>
             
                    <HistoryPlugin />
                    <AutoFocusPlugin />
                    <CodeHighlightPlugin />
                    <ListPlugin />
                    <LinkPlugin />
                    <AutoLinkPlugin />
                    <ListMaxIndentLevelPlugin maxDepth={7} />
                    <MarkdownShortcutPlugin transformers={TRANSFORMERS} />

                    </div>

                    </div>
                  </div>
                  <div className='flex flex-row'>
                  <div className="shadow-l bg-gray-50 border-t pt-3 pb-2 w-full rounded-b-lg">
                            <div className='flex flex-row justify-between pl-4'>
                                <div className="relative flex w-full h-12 rounded-xl bg-white border mr-10">
                                    <input
                                        className="h-full w-full border-0 text-sm text-gray-700 pr-2 focus:outline-none focus:ring-1 rounded-l-xl focus:ring-blue-200 focus:border-transparent"
                                        type="text"
                                        id="search"
                                        autoComplete="off"
                                        placeholder="Type your message..."
                                        value={userInput}
                                        onChange={(e) => setUserInput(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' && !e.shiftKey) {
                                                e.preventDefault();
                                                setLoading(true);
                                                generateContent();
                                                setUserInput('');
                                            }
                                        }}
                                    />
                                    <div onClick={() => { setLoading(true); generateContent(); setUserInput(''); }} className="place-items-center h-full w-30 text-gray-300 bg-blue-200 hover:bg-blue-500 text-white rounded-r-xl flex">
                                        <div className="text-sm font-medium leading-6 text-white pl-2 w-16">Generate</div>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 ml-2 mr-2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
                                        </svg>
                                    </div>

                                </div>
                                <div className="pl-4 pr-4 mt-2 mb-2 flex justify-end">
                                    <button
                                        onClick={() => createContent()}
                                        type="submit"
                                        className="rounded-md bg-blue-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
              </div>

            </div>
          </div>
        </div>
    </LexicalComposer>
  );
}

